// base-x encoding
// Forked from https://github.com/cryptocoinjs/bs58
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc
// Modified by Mark Holt (mark.holt@distributed.vision)
// to conform to general DV packaging model
// Copyright (c) 2013 Distributed Vision Ltd

export class Encoder {
  ALPHABET;
  ALPHABET_MAP;
  BASE;
  LEADER;

  constructor(ALPHABET) {
    this.ALPHABET = ALPHABET;
    this.ALPHABET_MAP = {};
    this.BASE = ALPHABET.length;
    this.LEADER = ALPHABET.charAt(0);

    // pre-compute lookup table
    for (var z = 0; z < ALPHABET.length; z++) {
      var x = ALPHABET.charAt(z);

      if (this.ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous');
      this.ALPHABET_MAP[x] = z;
    }
  }

  encode(source) {
    if (!source || source.byteLength === 0) return '';

    let BASE=this.BASE;
    let ALPHABET=this.ALPHABET;
    let LEADER=this.LEADER;

    var digits = [0];
    for (var i = 0; i < source.byteLength; ++i) {
      for (var j = 0, carry = source[i]; j < digits.length; ++j) {
        carry += digits[j] << 8;
        digits[j] = carry % BASE;
        carry = (carry / BASE) | 0;
      }

      while (carry > 0) {
        digits.push(carry % BASE);
        carry = (carry / BASE) | 0;
      }
    }

    let string = '';
    // deal with leading zeros
    for (var k = 0; source[k] === 0 && k < source.byteLength - 1; ++k) string += LEADER;
    // convert digits to a string
    for (var q = digits.length - 1; q >= 0; --q) string += ALPHABET[digits[q]];

    return string;
  }

  decode (string) {
    if (typeof string !== 'string') throw new TypeError('Expected String');
    if (string.length === 0) return new Uint8Array(0);

    let BASE = this.BASE;
    let ALPHABET_MAP = this.ALPHABET_MAP;
    let LEADER = this.LEADER;

    var bytes = [0];
    for (var i = 0; i < string.length; i++) {
      var value = ALPHABET_MAP[string[i]];
      if (value === undefined) {
        throw new Error('Non-base' + this.BASE + ' character');
      }

      for (var j = 0, carry = value; j < bytes.length; ++j) {
        carry += bytes[j] * BASE;
        bytes[j] = carry & 0xff;
        carry >>= 8;
      }

      while (carry > 0) {
        bytes.push(carry & 0xff);
        carry >>= 8;
      }
    }

    // deal with leading zeros
    for (var k = 0; string[k] === LEADER && k < string.length - 1; ++k) {
      bytes.push(0);
    }

    return new Uint8Array(bytes.reverse());
  }
}
